import styled from 'styled-components';

export const Button = styled.button`
  background: white;
  border-radius: 5px;
  padding: 5px;
  border: solid 0.5px;
`;

export const PrimaryButton = styled.button`
  background: blue;
  border-radius: 5px;
  padding: 5px;
  border: solid 0.5px;
`;

export const customStyles = `
    overflow: hidden;
    background-color: white;
    max-height: 100%;
  `;

export const ModalBodyContainer = styled.div`
  background: white;
  height: 150px;
  padding-top: 15px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 3.75rem;
`;
